<template>
  <div>
    <!-- Show GuestHeader when not authenticated and on public route -->
    <GuestHeader v-if="!hasAccess() && isPublicRoute" />
    <!-- Show regular Header when authenticated or on private route -->
    <Header v-else-if="isLaptop === 1" />
    <MobileHeader v-else-if="isLaptop === 2 && showHeader && isValidRoute" />
    <AppMain />
    <!-- Slim (64px) by default, expands to 275px on hover -->
    <div
      v-if="isLaptop === 1 && hasAccess()"
      :class="
        sidebarHover || isNavigating ? 'sidebar-expanded' : 'sidebar-collapsed'
      "
      class="main-leftpart-fixed"
      @mouseenter="sidebarHover = true"
      @mouseleave="handleMouseLeave"
    >
      <MainLeftpart
        :expanded="sidebarHover || isNavigating"
        @navigating="handleNavigating"
      />
    </div>
    <MobBottomNav v-if="isLaptop === 2 && !hasAccess() && isPublicRoute" />
  </div>
</template>

<script>
import AppMain from "../../components/Layout/AppMain.vue";
import Header from "../../components/NewCandidateDashboard/LandingpageHeader.vue";
import GuestHeader from "@/components/fixedComponents/GuestHeader.vue";
import MainLeftpart from "@/components/NewCandidateDashboard/MainLeftpart.vue";
import MobileHeader from "../../components/NewCandidateDashboard/NcdTopContainer.vue";
import laptopCheck from "../mixin/laptopCheck";
import { eventBus } from "@/utils/eventBus";
import { getProcessedToken } from "@/utils/request";
import MobBottomNav from "@/components/fixedComponents/MobBottomNav.vue";
import { mapGetters } from "vuex";
import { hasAccess } from "@/utils/tokenCheck";
export default {
  name: "NewLayout",
  components: {
    Header,
    GuestHeader,
    AppMain,
    MainLeftpart,
    MobileHeader,
    MobBottomNav,
  },
  data() {
    return {
      showHeader: true,
      sidebarHover: false,
      isNavigating: false,
    };
  },
  mixins: [laptopCheck],
  computed: {
    ...mapGetters("userVUEX", {
      vuexToken: "getToken",
    }),
    isAuthenticated() {
      // Check if user has a valid token reactively
      return !!(this.vuexToken || getProcessedToken());
    },
    isValidRoute() {
      const excludedRoute = ["Instructor", "CourseDetail", "Assessments"];
      return !excludedRoute.includes(this.$route.name);
    },
    isPublicRoute() {
      // Check if current route is marked as public
      return this.$route.meta?.isPublic === true;
    },
  },
  methods: {
    hasAccess() {
      return hasAccess();
    },
    handleMouseLeave() {
      if (!this.isNavigating) {
        this.sidebarHover = false;
      }
    },
    handleNavigating() {
      this.isNavigating = true;
      this.sidebarHover = true;
    },
    resetSidebar() {
      this.isNavigating = false;
      this.sidebarHover = false;
    },
  },
  mounted() {
    eventBus.$on("toggle-header", (data) => {
      this.showHeader = data;
    });
    window.addEventListener("popstate", this.resetSidebar);
    window.addEventListener("pageshow", (e) => {
      if (e.persisted) this.resetSidebar();
    });
  },
  beforeDestroy() {
    window.removeEventListener("popstate", this.resetSidebar);
  },
};
</script>

<style>
.main-leftpart-fixed {
  position: fixed;
  top: 62px;
  left: 0;
  height: calc(100vh - 65px);
  z-index: 100;
  overflow: hidden;
  white-space: nowrap;
  transition: width 0.25s ease;
  background: #ffffff;
  border-right: 1px solid #e2e8f0;
  padding: 24px 8px 24px 8px;
  display: flex;
}

.sidebar-collapsed {
  width: 64px;
}

.sidebar-expanded {
  width: 275px;
  overflow-y: auto;
}
</style>
